import { render, staticRenderFns } from "./submitarticle.vue?vue&type=template&id=10464149&scoped=true&"
import script from "./submitarticle.vue?vue&type=script&lang=js&"
export * from "./submitarticle.vue?vue&type=script&lang=js&"
import style0 from "./submitarticle.vue?vue&type=style&index=0&id=10464149&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10464149",
  null
  
)

export default component.exports